module.exports = __webpack_public_path__ + "img/DJI_0086(1).0b3e4651.jpg";